export interface TransactionHistoryLogs {
  booking_line_id: number;
  booking_line_order_id: string;
  start_date: string;
  end_date: string;
  type?: string;
}

export const getTransactionHistoryLogsType = (
  t: (key: string) => string
): { [key: string]: string } => ({
  // room_charge_revenue: 'Room Charge Revenue',
  // service_breakfast_revenue: 'Breakfast Service Revenue',
  // service_revenue: 'Service Revenue',
  // payment: 'Payment',
  // refund: 'Refund',
  void_transaction: t('transactionHistoryLogs.voidTransaction'),
  move_transaction: t('transactionHistoryLogs.moveTransaction'),
  undo_voided_transaction: t('transactionHistoryLogs.undoVoidedTransaction'),
  change_room_charge: t('transactionHistoryLogs.changeRoomCharge'),
  move_sale_order: t('transactionHistoryLogs.moveSaleOrder'),
  split_transaction: t('transactionHistoryLogs.splitTransaction')
});
